import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Calendar, Mail, Phone, ArrowRight, MessageSquare, Upload } from "lucide-react";
import { JEREMY, PHOTOS } from "@/lib/jeremy";

export default function ThankYouPage() {
  const { state } = useLocation();
  const name = state?.name || "there";
  const when = state?.when ? new Date(state.when).toLocaleString() : null;
  const digits = JEREMY.contact.phone.replace(/\D/g, "");

  return (
    <main className="pt-28 md:pt-36 pb-24 min-h-screen bg-[#FDFBF7]" data-testid="thank-you-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="card-warm p-8 md:p-12">
          <div className="flex items-start gap-5 mb-6">
            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-[#D97706] shrink-0">
              <img src={PHOTOS.character} alt="Jeremy" className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <div className="eyebrow" data-testid="thank-you-eyebrow">Received</div>
              <h1 className="mt-1 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C]">
                Thanks, {name}! Jeremy received your information.
              </h1>
            </div>
          </div>

          <p className="text-lg text-slate-600">
            Jeremy will review your property and utility information before contacting you. If the home appears eligible, he'll explain the next step and answer your questions.
            <span className="block mt-1 text-xs text-slate-400">(Email/SMS/CRM delivery is MOCKED in this demonstration build.)</span>
          </p>

          {when && (
            <div className="mt-6 inline-flex items-center gap-3 rounded-full bg-[#FEF3C7] text-[#B45309] px-5 py-2.5 font-mono-metric text-sm">
              <Calendar className="w-4 h-4" /> Consultation requested: {when}
            </div>
          )}

          <div className="mt-10 grid sm:grid-cols-2 gap-3">
            <a href={`tel:${digits}`} className="rounded-2xl border border-[#E5E0D8] hover:border-[#D97706] p-5 flex items-center gap-4 transition" data-testid="thank-you-call-link">
              <div className="w-10 h-10 rounded-xl bg-[#0F382C] flex items-center justify-center"><Phone className="w-4 h-4 text-[#FEF3C7]" /></div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">Call Jeremy</div>
                <div className="text-xs text-slate-500 font-mono-metric">{JEREMY.contact.phone}</div>
              </div>
            </a>
            <a href={`sms:${digits}`} className="rounded-2xl border border-[#E5E0D8] hover:border-[#D97706] p-5 flex items-center gap-4 transition" data-testid="thank-you-text-link">
              <div className="w-10 h-10 rounded-xl bg-[#0F382C] flex items-center justify-center"><MessageSquare className="w-4 h-4 text-[#FEF3C7]" /></div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">Text Jeremy</div>
                <div className="text-xs text-slate-500 font-mono-metric">{JEREMY.contact.text}</div>
              </div>
            </a>
            <Link to="/qualify?upload=1" className="rounded-2xl border border-[#E5E0D8] hover:border-[#D97706] p-5 flex items-center gap-4 transition" data-testid="thank-you-upload-link">
              <div className="w-10 h-10 rounded-xl bg-[#0F382C] flex items-center justify-center"><Upload className="w-4 h-4 text-[#FEF3C7]" /></div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">Upload an electric bill</div>
                <div className="text-xs text-slate-500">Speeds up the consultation.</div>
              </div>
            </Link>
            <Link to="/how-solar-works" className="rounded-2xl border border-[#E5E0D8] hover:border-[#D97706] p-5 flex items-center gap-4 transition" data-testid="thank-you-learn-link">
              <div className="w-10 h-10 rounded-xl bg-[#0F382C] flex items-center justify-center"><Mail className="w-4 h-4 text-[#FEF3C7]" /></div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">Keep learning</div>
                <div className="text-xs text-slate-500">Watch Jeremy Explains Solar</div>
              </div>
            </Link>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="btn-ghost-forest text-sm" data-testid="thank-you-home-link">
              Back to home <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
